import { Edit } from "@mui/icons-material";
import {
  Button,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { TrainingArea } from "../../model/entity/TrainingArea";
import handleAxiosError from "../../components/ErrorHandler";
import { notifErr } from "../../components/Functions";
import { Loading } from "../../components/Loading";
import { getFetcher } from "../../components/Fetchers";

const TrainingAreas = () => {
  const navigate = useNavigate();
  const [trainingAreas, setTrainingAreas] = useState<TrainingArea[] | null>(
    null
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/training-areas/sorted-by-name`
        );
        setTrainingAreas(response.data);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };
    fetchData();
  }, []);

  if (trainingAreas === null) return <Loading />;

  return (
    <div className="tableContainer" style={{ marginBottom: "1rem" }}>
      <div
        style={{
          width: "35%",
          display: "flex",
          justifyContent: "left",
          marginBottom: "0.65rem",
        }}
      >
        <Button
          className="submitBtn"
          onClick={() => navigate("/schedule/training-areas/add-new")}
        >
          Nové sportoviště
        </Button>
      </div>
      <Paper
        elevation={trainingAreas.length ? 3 : 0}
        className="tableContainer"
        sx={{ width: "35%", maxHeight: "49rem" }}
      >
        <TableContainer>
          <Table size="small">
            <TableHead
              sx={{
                position: "sticky",
                top: 0,
                zIndex: 2,
              }}
            >
              <TableRow className="tableHeader">
                <TableCell className="tableHeaderCell tableHeaderFirstCell">
                  Název
                </TableCell>
                <TableCell className="tableHeaderCell">Kód</TableCell>
                <TableCell className="tableHeaderCell tableHeaderLastCell">
                  Upravit
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {trainingAreas.map((area) => (
                <TableRow key={area.id} className="tableRow">
                  <TableCell className="tableCell tableFirstCell">
                    {area.name}
                  </TableCell>
                  <TableCell className="tableCell">{area.code}</TableCell>
                  <TableCell
                    className="tableCell tableLastCell"
                    onClick={() => {
                      navigate(`/schedule/training-areas/edit/${area.id}`);
                    }}
                  >
                    <Edit className="editBtn" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default TrainingAreas;
